<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAnalyticsChart_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M10.368 4a1 1 0 0 0-1 1v11.158a1 1 0 0 0 1 1h2.737a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM5.105 8.21a1 1 0 0 0-1 1v6.948a1 1 0 0 0 1 1h2.21a1 1 0 0 0 1-1V9.21a1 1 0 0 0-1-1zm10.053 1a1 1 0 0 1 1-1h2.21a1 1 0 0 1 1 1v6.948a1 1 0 0 1-1 1h-2.21a1 1 0 0 1-1-1zM3.053 18.738a1.053 1.053 0 0 0 0 2.105h17.894a1.053 1.053 0 0 0 0-2.105z"
        clip-rule="evenodd"
    />
</svg>
